export default __webpack_public_path__ + "static/media/Faruk.0db98a42.jpeg";